// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

function BuildingSvg() {
    return (
        <svg
            width='133'
            height='106'
            viewBox='0 0 133 106'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect
                x='32.5'
                y='0.5'
                width='68.5'
                height='105'
                rx='4'
                fill='#FFBC1F'
            />
            <rect
                x='0.5'
                y='37'
                width='132.5'
                height='68.5'
                rx='4'
                fill='#CC8F00'
            />
            <path
                d='M101 3.32155V103.178C100.83 104.887 100.246 105.827 99.2368 106H34.5181C33.3391 105.827 32.6699 104.887 32.5 103.178V3.32155C32.6699 1.61349 33.3391 0.672969 34.5181 0.5H99.2368C100.246 0.672969 100.83 1.61349 101 3.32155Z'
                fill='#FFBC1F'
            />
            <path
                d='M80.0115 79.0244H53.7559V105.989H80.0115V79.0244Z'
                fill='#E8E9ED'
            />
            <rect
                x='30.5'
                y='0.5'
                width='72.5'
                height='7'
                rx='1.5'
                fill='#1E325C'
            />
            <rect
                x='51'
                y='75.5'
                width='31.5'
                height='7'
                rx='1.5'
                fill='#1E325C'
            />
            <rect
                x='66'
                y='82'
                width='2'
                height='24'
                fill='#1E325C'
            />
            <rect
                x='6.5'
                y='49'
                width='8'
                height='15.5'
                rx='1.5'
                fill='#7A5600'
            />
            <rect
                x='38'
                y='14'
                width='9'
                height='19'
                rx='1.5'
                fill='#CC8F00'
            />
            <rect
                x='73'
                y='14'
                width='9'
                height='19'
                rx='1.5'
                fill='#CC8F00'
            />
            <rect
                x='38'
                y='38'
                width='9'
                height='19'
                rx='1.5'
                fill='#CC8F00'
            />
            <rect
                x='38'
                y='62'
                width='9'
                height='9'
                rx='1.5'
                fill='#CC8F00'
            />
            <rect
                x='38'
                y='75.5'
                width='9'
                height='9'
                rx='1.5'
                fill='#CC8F00'
            />
            <rect
                x='38'
                y='89'
                width='9'
                height='9'
                rx='1.5'
                fill='#CC8F00'
            />
            <rect
                x='73'
                y='38'
                width='9'
                height='19'
                rx='1.5'
                fill='#CC8F00'
            />
            <rect
                x='73'
                y='62'
                width='9'
                height='9'
                rx='1.5'
                fill='#CC8F00'
            />
            <rect
                x='51'
                y='14'
                width='9'
                height='19'
                rx='1.5'
                fill='#CC8F00'
            />
            <rect
                x='86'
                y='14'
                width='9'
                height='19'
                rx='1.5'
                fill='#CC8F00'
            />
            <rect
                x='51'
                y='38'
                width='9'
                height='19'
                rx='1.5'
                fill='#CC8F00'
            />
            <rect
                x='51'
                y='62'
                width='9'
                height='9'
                rx='1.5'
                fill='#CC8F00'
            />
            <rect
                x='86'
                y='38'
                width='9'
                height='19'
                rx='1.5'
                fill='#CC8F00'
            />
            <rect
                x='86'
                y='62'
                width='9'
                height='9'
                rx='1.5'
                fill='#CC8F00'
            />
            <rect
                x='86'
                y='75.5'
                width='9'
                height='9'
                rx='1.5'
                fill='#CC8F00'
            />
            <rect
                x='86'
                y='89'
                width='9'
                height='9'
                rx='1.5'
                fill='#CC8F00'
            />
            <rect
                x='107'
                y='49'
                width='8'
                height='15.5'
                rx='1.5'
                fill='#7A5600'
            />
            <rect
                x='6.5'
                y='70.5'
                width='8'
                height='8'
                rx='1.5'
                fill='#7A5600'
            />
            <rect
                x='107'
                y='70.5'
                width='8'
                height='8'
                rx='1.5'
                fill='#7A5600'
            />
            <rect
                x='6.5'
                y='85'
                width='8'
                height='8'
                rx='1.5'
                fill='#7A5600'
            />
            <rect
                x='107'
                y='85'
                width='8'
                height='8'
                rx='1.5'
                fill='#7A5600'
            />
            <rect
                x='18.5'
                y='49'
                width='8'
                height='15.5'
                rx='1.5'
                fill='#7A5600'
            />
            <rect
                x='119'
                y='49'
                width='8'
                height='15.5'
                rx='1.5'
                fill='#7A5600'
            />
            <rect
                x='18.5'
                y='70.5'
                width='8'
                height='8'
                rx='1.5'
                fill='#7A5600'
            />
            <rect
                x='119'
                y='70.5'
                width='8'
                height='8'
                rx='1.5'
                fill='#7A5600'
            />
            <rect
                x='18.5'
                y='85'
                width='8'
                height='8'
                rx='1.5'
                fill='#7A5600'
            />
            <rect
                x='119'
                y='85'
                width='8'
                height='8'
                rx='1.5'
                fill='#7A5600'
            />
        </svg>

    );
}

export default BuildingSvg;
